import { create } from 'zustand';

interface TourState {
	tourTrigger: boolean;
	setTriggerTour: (value: boolean) => void;
	currentPageRoute: string | null;
	setCurrentPageRoute: (pageUrl: string) => void;
	lastStep: number;
	setLastStep: (step: number) => void;
	pageReadyMap: Record<string, boolean>;
	notifyPageReady: (pageUrl: string) => void;
	resetPageReady: (pageUrl: string) => void;
	selectedNetworkUserId: string | null;
	setSelectedNetworkUserId: (userId: string | null) => void;
}

const useTourStore = create<TourState>((set) => ({
	tourTrigger: false,
	setTriggerTour: (value) => set(() => ({ tourTrigger: value })),
	currentPageRoute: null,
	setCurrentPageRoute: (pageUrl) => set({ currentPageRoute: pageUrl }),
	lastStep: 0,
	setLastStep: (step: number) => set({ lastStep: step }),
	pageReadyMap: {} as Record<string, boolean>,
	notifyPageReady: (pageUrl) => set((state) => ({ pageReadyMap: { ...state.pageReadyMap, [pageUrl]: true } })),
	resetPageReady: (pageUrl) => set((state) => ({ pageReadyMap: { ...state.pageReadyMap, [pageUrl]: false } })),
	selectedNetworkUserId: null,
	setSelectedNetworkUserId: (userId) => set({ selectedNetworkUserId: userId })
}));

export default useTourStore;
